import { ConfirmationDialog, ModalInjectedProps } from '@sketch/components'
import React from 'react'

import { useToast } from '@sketch/toasts'
import { useUpdateWorkspaceProfileMutation } from '@sketch/gql-types'

interface UnpublishProfileModalProps extends ModalInjectedProps {
  identifier: string
}

export const UnpublishProfileModal: React.FCC<
  UnpublishProfileModalProps
> = props => {
  const { hideModal, isModalOpen, identifier } = props
  const { showToast } = useToast()

  const [unpublishProfile, { loading }] = useUpdateWorkspaceProfileMutation({
    onCompleted: () => {
      showToast('Public profile successfully hidden')
      hideModal()
    },
    onError: message => showToast(message.message, 'negative'),
    variables: {
      input: {
        identifier,
        isPublic: false,
      },
    },
  })

  return (
    <ConfirmationDialog
      title="Hide Public Profile?"
      hideModal={hideModal}
      isModalOpen={isModalOpen}
      cancelButton={{
        disabled: loading,
      }}
      confirmButton={{
        text: 'Hide Profile',
        variant: 'primary',
        loading,
        disabled: loading,
      }}
      onConfirm={unpublishProfile}
    >
      <p>
        Only you and other Admins in this Workspace will be able to see your
        hidden profile. You can always publish it again later.
      </p>
    </ConfirmationDialog>
  )
}
